import React, { FC } from 'react';
import AccordionItemUI from '@app/components/ui/Accordion/AccordionItem';
import {
  MonitoringFormInfoType,
  MonitoringFormListObjectType,
} from '@app/interfaces/qm-module/qm-manage/qm-monitoring-forms.type';
import RubberTable from '@app/components/rubber-table';
import useTranslation from '@app/hooks/use-translation';
import { TableColumn, TableItem } from '@app/components/rubber-table/table.types';

import { ColsWithoutTable } from '@app/components/rubber-table/blocks/cols-without-table';

import MonitoringFormsAccordionTitle from './monitoringFormsAccordionTitle';

type MonitoringFormsTablePropsType = {
  accordionsListData: MonitoringFormListObjectType[];
  reformatMFListForTable(mforms: MonitoringFormInfoType[]): TableItem[];
};

const MonitoringFormsTable: FC<MonitoringFormsTablePropsType> = (props) => {
  const { t } = useTranslation('pages.qmManage.monitoring_forms.table');
  const { accordionsListData, reformatMFListForTable } = props;

  const [activeAccordionItem, setActiveAccordionItem] = React.useState<string[]>([]);

  function handleAccordionClick({ id }: { id: string }) {
    const formattedAccordionArray = activeAccordionItem.includes(id)
      ? activeAccordionItem.filter((accordionItem) => accordionItem !== id)
      : [...activeAccordionItem, id];
    setActiveAccordionItem(formattedAccordionArray);
  }

  const tableColumns: TableColumn[] = [
    { index: 'name', title: t('name') },
    { index: 'dt_add', title: t('dt_add') },
    { index: 'status', maxWidth: 180, title: t('status') },
    { index: 'actions', maxWidth: 160, title: t('actions'), divider: 'left' },
  ];

  return (
    <>
      <div className="h-full flex flex-col relative">
        {!!accordionsListData.length && (
          <div>
            <ColsWithoutTable columns={tableColumns} />
          </div>
        )}
        {accordionsListData.map(({ project_id, project_name, mforms }) => {
          const isOpened = activeAccordionItem.includes(project_id);
          return (
            <AccordionItemUI
              variant="filled"
              key={project_name + project_id}
              title={
                <MonitoringFormsAccordionTitle
                  formId={project_id}
                  title={project_name}
                  isOpened={isOpened}
                  count={mforms.length}
                />
              }
              id={project_id}
              active={isOpened}
              clickBtnChild={handleAccordionClick}
            >
              <RubberTable
                truncate={false}
                withoutCols
                dataSource={reformatMFListForTable(mforms)}
                columns={tableColumns}
              />
            </AccordionItemUI>
          );
        })}
      </div>
    </>
  );
};

export default MonitoringFormsTable;
